<template>
    <div class="mt-4 row">
        <div class="row mb-5">
            <div class="col-12 col-lg-10 mt-3 my-lg-0 px-0 mx-auto">
                <div class="row g-0 justify-content-evenly justify-content-sm-center align-items-center">
                    <div class="col-auto">
                        <a :href="'/structure/student/session/CalendarAction?userId=' + userId"
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': false
                            }">Calendario</a>
                    </div>
                    <div class="col-auto">
                        <a 
                            :class="{
                                'erk btn btn-outline-secondary': true,
                                'active': true,
                            }">Elenco</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-10 mx-auto text-center mb-5">
            <button @click="onClickNewSession" class="btn btn-secondary me-2">
                Nuova attività
            </button>
        </div>

        <MbLoading v-if="isLoading"></MbLoading>
        <div v-else class="col-lg-10 mx-auto">
            <div v-if="sessions.length === 0" class="text-center">
                <p class="lead">Nessuna attività pianificata</p>
            </div>
            <div v-else v-for="session in sessions" :key="session.user_structure_session_id" class="row pb-2 mb-2">
                <div class="col-12 d-flex">
                    <div class="me-3 display-6 pt-2">
                        <i v-if="session.remote" class="bi bi-cloud-fill"></i>
                        <i v-else class="bi bi-person-fill"></i>
                    </div>
                    <div>
                        <a :href="session.url">
                            <h4 class="card-title mb-1">
                                <template v-if="session.title">
                                    {{ session.title }}
                                </template>
                                <template v-else-if="session.remote">
                                    Attività da remoto
                                </template>
                                <template v-else>
                                    Attività in studio
                                </template>
                            </h4>
                        </a>
                        <p>
                            {{ session.timeStr }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <MbSessionForm ref="adddSessionModal" 
            :userId="parseInt(userId)"
            @reload="load()"></MbSessionForm>
    </div>
</template>
<script>

import MbLoading from '@/components/ui/base/MbLoading.vue'
import axios from 'axios'
import MbSessionForm from './MbSessionForm.vue';

export default {
    components: {
        MbLoading,
        MbSessionForm
    },
    props: {
        userId: Number
    },
    data() {
        return {
            isLoading: true,
            sessions: []
        }
    },
    destroy(){

    },
    mounted() {
        this.load()
    },
    methods: {
        load(){
            this.isLoading = true;
            axios.get('/structure/student/session/ListAction-events?outFormat=json&userId=' + this.userId)
                .then(response => {
                    this.isLoading = false;
                    this.sessions = response.data
                }).catch(() => {
                    this.isLoading = false;
                });
        },
        onClickNewSession(){
            this.$refs.adddSessionModal.toggle()
        },
    }
}

</script>